module.exports = __webpack_public_path__ + "img/ic_peakpower.cf10d9fd.svg";